import React from "react";
import FloatingCard from "../common/FloatingCard";
import "./style.css";
import data from "./data";

function Education() {
  return (
    <div className="education-big-container">
      <div className="education-title-container">
        <h1>Education</h1>
      </div>
      {data.map((education) => {
        return (
          <FloatingCard
            container="education-container"
            card="education-card"
            content={<Content data={education} />}
          />
        );
      })}
    </div>
  );
}

function Content({ data }) {
  return (
    <div className="education-description-container">
      <h3>{data.school}</h3>
      <h4>{data.stream}</h4>
      <p>{data.date}</p>
      <ul>
        {data.achievements.map((achievement) => {
          return <li>{achievement}</li>;
        })}
      </ul>
    </div>
  );
}

export default Education;
